<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <!-- <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()">新建</el-button> -->
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <!-- <el-table-column prop="userId" label="用户Id" align="center" width="80px"></el-table-column> -->
                <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
                <el-table-column prop="alipayCount" label="支付宝账号" align="center"></el-table-column>
                <el-table-column prop="userName" label="真实姓名" align="center"></el-table-column>
                <!-- <el-table-column prop="balance" label="提现金额" align="center"></el-table-column> -->
                <el-table-column prop="balance" label="提现金额" align="center"></el-table-column>
                <!-- <el-table-column prop="rate" label="费率" align="center"></el-table-column> -->
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <el-tag type="warning" v-if="scope.row.status==0">待审核</el-tag>
                        <el-tag type="success" v-if="scope.row.status==1">审核完成</el-tag>
                        <el-tag type="danger" v-if="scope.row.status==-1">审核不通过</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createdAt" label="创建时间" align="center"></el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="editTip(scope.row)">审核</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑" width="500px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        支付宝账号
                    </div>
                    <div class="value">
                        <el-input disabled v-model="formData.alipayCount" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        提现金额
                    </div>
                    <div class="value">
                        <el-input disabled v-model="formData.balance" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        费率
                    </div>
                    <div class="value">
                        <el-input disabled v-model="formData.rate" size="small" placeholder="请输入"></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        提现金额
                    </div>
                    <div class="value">
                        <el-input disabled v-model="formData.balance" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        状态
                    </div>
                    <div class="value">
                        <el-select v-model="formData.status" placeholder="请选择">
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
              
                
                <div class="btns">
                    <el-button type="primary" @click="edit">确认</el-button>
                </div>
            </div>
        </el-dialog>


        
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {wtlxList,isNewList} from '../../../assets/selectList/index'
import {parseTimeS} from '../../../utils/index'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,

            totalCount:0,
            tableData:[],
            conditionData:{
                // 任务类型
                alipayCount:'',
                // 任务状态
                status:'',
                current:1,
                size:10,
            },
            queryList:[
                {type: "input",label: "支付宝账号:",name: "alipayCount"},
                {type: "select",label: "状态:",name: "status",options:[{
                    label:'待审核',
                    value:0,
                },{
                    label:'审核完成',
                    value:1,
                },{
                    label:'审核不通过',
                    value:-1,
                }]},
            ],
            
            statusList:[{
                    label:'待审核',
                    value:0,
                },{
                    label:'审核完成',
                    value:1,
                },{
                    label:'审核不通过',
                    value:-1,
                }
            ],
            formData:{
                
            },
            formList:[
                {type: "input",label: "支付宝账号:",name: "alipayCount"},
                {type: "input",label: "提现金额:",name: "title"},
                {type: "input",label: "费率:",name: "rate",},
                {type: "input",label: "实际金额:",name: "total"},
                {type: "status",label: "状态:",name: "status",options:[{
                    label:'待审核',
                    value:0,
                },{
                    label:'审核完成',
                    value:1,
                },{
                    label:'审核不通过',
                    value:-1,
                }]},
                
            ],
            // 提交规则
            formRules:{
               
            },
            formAddBtns:[
                {name:'确认新增',icon:'el-icon-circle-plus',type:'success',handleClick:this.add},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
            formEditBtns:[
                {name:'确认编辑',icon:'el-icon-edit',type:'success',handleClick:this.edit},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
        }
    },
    created(){
    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
        clear(index){
            this.formData.mediaUrl.splice(index,1)
        },
        async uploadImg(file){
            let res= await api.uploadFile(file.file);
            this.formData.mediaUrlList.push(res);
        },
        showImg(url){
            this.showBigImgList = [url];
            this.showBigImg = true;
        },
        addDialogShow(){
            this.isAddDialog = true;
        },
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.selectMarkeCash({
                current:this.conditionData.current,
                size:this.conditionData.size,
                alipayCount:this.conditionData.alipayCount,
                status:this.conditionData.status,
            });
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
        },
        // 查询
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                alipayCount:'',
                status:null,
                current:1,
                size:10,
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        // 新增弹窗
        showAddDialog(e){
            this.isAddDialog = true;
        },
        // 新增方法
        async add(){
            
            let res  = await api.saveTask(this.formData);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.$refs["formListAdd"].resetFields();
                this.isAddDialog = false;
                this.loadingData();
            }
        },
        
        // 编辑方法
        // async edit(){
        //     let res = await api.updateMarkeCash(this.formData);
        //     if(res.data.code == '200'){
        //         this.$message({
        //             type: 'success',
        //             message: '操作成功'
        //         });  
        //         this.isUpdateDialog = false;
        //         this.loadingData();
        //         this.formData = {
        //             id:null,
        //             taskType:'',
        //             appStoreTitle:'',
        //             content:'',
        //             mediaUrl:[],
        //             reward:null,
        //             taskStatus:'',
        //             userId:null,
        //             proofImageUrl:'',
        //             proofLink:'',
        //             failureReason:'',
        //         }
        //     }
        // },
        // 关闭新增和编辑的弹框
        close(){
            if(this.isAddDialog){
                this.isAddDialog = false
            }else if(this.isUpdateDialog){
                this.isUpdateDialog = false
                this.$refs["formListEdit"].resetFields();
            }
        },
        // 删除提示
        deleteRowTip(row){
            this.$confirm('将删除委托主体——'+row.name+', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRow(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        // 删除方法
        async deleteRow(row){
            let res  = await api.AgentDeleteAgent({id:row.id});
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },


        editTip(item){
            this.isUpdateDialog = true;
            this.formData = item;
            this.formData.taskStatus = null
            this.$forceUpdate();
        },
        async edit(){
            let res = await api.updateMarkeCash(this.formData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功'
                });  
                this.isUpdateDialog = false;
                this.loadingData();
                this.formData = {
                    id:null,
                    userId:'',
                    phone:'',
                    logo:'',
                    agentName:'',
                    custName:'', 
                    loginWel:'',
                    yongJinRatio:'',
                    yaoQingUrl:'',  
                }
            }
        },


        deleteTip(item){
            this.$confirm('将删除此代理?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async del(item){
            let res = await api.AgentDeleteAgent(item.id);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 150px;
                margin-bottom: 5px;
            }
            .value{
                display: flex;
                width: 400px;
            }
            .input{
                width: 215px;
                display: flex;
            }
        }
        .picList{
            display: flex;
            flex-wrap: wrap;
            margin:0 10px;
            .pic{
                position: relative;
                margin: 5px;
                width: 100px;
                height: 100px;
                .pic-edit{
                    position: absolute;
                    z-index: 10;
                    top: -10px;
                    right: -10px;
                    width: 22px;
                    height: 22px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    i{
                        color: #ffffff;
                    }
                    .error{
                        color: #f56c6c;
                    }
                    .success{
                        color: #a9ffa9;
                    }
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            justify-content: center;
            .el-button{
                margin-right: 10px;
            }
        }
    }
    :deep(.el-input.is-disabled .el-input__inner){
        color: #222222;
    }
    :deep(.el-textarea.is-disabled .el-textarea__inner){
        color: #222222;
    }
    .cursor{
        cursor: pointer;
    }
</style>
